/**
 * Set the Disney EULA cookie
 */
$('#disney-eula-accept').on('click', function () {
    Cookies.set('disney-eula-setting', '1', { sameSite: 'lax', secure: true });
    $('#submit-borrow')
        .removeAttr('data-reveal-id')
        .attr('href', $(this).attr('href'))
        .attr('target', '_blank')
        .attr('rel', 'noreferrer');
    $('#disney-eula-modal').foundation('reveal', 'close');
});

$('#sample-modal').on('opened.fndtn.reveal', function () {
    var iframe = $('#sample-iframe');
    var sampleLink = iframe.attr('data-src');
    iframe.attr('src', sampleLink);
});
